<!--Edit Panel Code  -->
<p-dialog [(visible)]="finraExceptionService.showEdit" header="" height="auto" width="auto"
  [style]="{width: '85%', minWidth: '550px', minHeight: '150px'}" [maximizable]="true" minimizeIcon="pi pi-window-minimize"
  maximizeIcon="pi pi-window-maximize" closeIcon="pi pi-times" [modal]="false" draggable="true" [focusOnShow]="false"
  styleClass="finra-exp-edit-dialog">
  <mat-horizontal-stepper (selectionChange)="selectionChange($event)" #matStepperOne>
     
      <mat-step label="Edit Row">
          @if(this.correctCodeLength !== 0){
          <div> You are editing {{correctCodeLength}} records</div>
          }
          <div class="ui-grid-col-12">
        
            <div class="ui-g-6 ui-md-6 ui-lg-6 quick-view-grid-row-main">
              <div class="ui-g-12 ui-md-6 ui-lg-2 quick-view-grid-row-main">
                <strong> Failure Code : </strong>
              </div>
              <div class="ui-g-12 ui-md-6 ui-lg-9 quick-view-grid-row-main">
                <textarea disabled style="color:red; width:100%" required type="text" pInputText
                  [(ngModel)]="finraException.failureCode">
                      </textarea>
              </div>
            </div>
            <div class="ui-g-6 ui-md-6 ui-lg-6 quick-view-grid-row-main">
              <div class="ui-g-12 ui-md-6 ui-lg-3 quick-view-grid-row-main">
                <strong> Failure Description : </strong>
              </div>
              <div class="ui-g-12 ui-md-6 ui-lg-9 quick-view-grid-row-main">
                <textarea disabled style="color:red; width:93%" required type="text" pInputText
                  [(ngModel)]="finraException.failureDescription">
                    </textarea>
              </div>
            </div>
            <div class="ui-g-6 ui-md-6 ui-lg-6 quick-view-grid-row-main">
              <div class="ui-g-12 ui-md-6 ui-lg-2 quick-view-grid-row-main">
                <strong> Actual Value : </strong>
              </div>
              <div class="ui-g-12 ui-md-6 ui-lg-9 quick-view-grid-row-main">
                <textarea disabled style="color:red; width:100%" required type="text" pInputText
                  [(ngModel)]="finraException.actualValue">
            </textarea>
              </div>
            </div>
            <div class="ui-g-6 ui-md-6 ui-lg-6 quick-view-grid-row-main">
              <div class="ui-g-12 ui-md-6 ui-lg-3 quick-view-grid-row-main">
                <strong> Suggested Value : </strong>
              </div>
              <div class="ui-g-12 ui-md-6 ui-lg-9 quick-view-grid-row-main">
                <textarea disabled style="color:green; width:93%" required type="text" pInputText
                  [(ngModel)]="finraException.suggestedValue"></textarea>
              </div>
            </div>
            
            @for(fieldDictionary of fieldDictionaryList; track fieldDictionary.uiFieldName + '-'+ $index; let i = $index) {
            <ng-container>
            @if(( (fieldDictionary.fieldName | lowercase) !== 'buydetails' && (fieldDictionary.fieldName | lowercase) !== 'selldetails' && (fieldDictionary.fieldName | lowercase) !== 'aggregatedorders'
              && (fieldDictionary.fieldName | lowercase) !== 'clientdetails' &&  (fieldDictionary.fieldName | lowercase) !== 'firmdetails' && (fieldDictionary.fieldName | lowercase) !== 'handlinginstructions'
              && (fieldDictionary.fieldName | lowercase) !== 'legdetails' && 
              (fieldDictionary.fieldName | lowercase) !== 'firmdesignatedid')){
              <ng-container>
                <span class="zindex ui-g-12 ui-md-12 ui-lg-4">
                  <!--Generic fields -->
                  <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
                    <div [ngClass]="this.correctCodeLength !== 0 ? 'ui-g-12 ui-md-5 ui-lg-5 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg'">
                      <label id="uiFieldName" class="edit-form-label">{{fieldDictionary.uiFieldName}}</label>
                    </div>
                    <div
                      [ngClass]="finraException.failureCode == fieldDictionary.errorCode ? 'error ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg' :'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg'">
                      @if((fieldDictionary?.uiDataType | lowercase) == 'choice'){
                      <ng-container>
                        <p-select [name]="fieldDictionary.fieldName +'choice'" [id]="fieldDictionary.fieldName+'choice'"  
                        [readonly]="fieldDictionary?.fieldName =='type' || fieldDictionary?.disabled" [options]="fieldDictionary.choiceDetails"
                          [(ngModel)]="fieldDictionary.jsonValue" appendTo="body"
                          [styleClass]="fieldDictionary.isMultiEdited ? 'drp-color-style-edit' : 'drp-color-style'"
                          [placeholder]="fieldDictionary.isMultiEdited ? 'Value cleared' : 'Enter Value'" 
                          (ngModelChange)="fieldDictionary.isMultiEdited=true"
                         filter="true" required="true" [showClear]="true">
                          <ng-template let-filterCols let-row pTemplate="item">
                            <div class="ui-helper-clearfix" style="text-transform:capitalize">
                              <div [matTooltip]="filterCols.description" [matTooltipShowDelay]="1000" matTooltipPosition="after"
                               [id]="filterCols.label">{{filterCols.label}}</div>
                            </div>
                          </ng-template>
                        </p-select>
                      </ng-container>
                      }
                      @else if((fieldDictionary.uiDataType | lowercase) === 'int' || (fieldDictionary.uiDataType | lowercase) === 'float' || 
                      (fieldDictionary.uiDataType | lowercase) === 'number' || (fieldDictionary.uiDataType | lowercase) === 'bigdecimal'){
                        <ng-container>
                          <input type="number" ng-pattern="constantService.NUMERIC_PATTERN" [name]="fieldDictionary.fieldName"
                            [id]="fieldDictionary.fieldName" maxlength="constantService.NUMERIC_MAXLENGTH" required 
                            [placeholder]="fieldDictionary.isMultiEdited ?'Value cleared' : 'Enter Value'" 
                            (ngModelChange)="fieldDictionary.isMultiEdited=true" 
                            [ngClass]="fieldDictionary.isMultiEdited ? 'input-color-edit' : 'inp-color-white'" pInputText [(ngModel)]="fieldDictionary.jsonValue" 
                            [disabled]="fieldDictionary.disabled"/>
                        </ng-container>
                      }
                      @else if((fieldDictionary.uiDataType | lowercase) === 'boolean'){
                        <ng-container>
                          <p-select [name]="fieldDictionary.fieldName +'boolean'" [id]="fieldDictionary.fieldName+'boolean'"
                           [options]="booleanDropDown" [(ngModel)]="fieldDictionary.jsonValue" appendTo="body"
                             filter="true" [styleClass]="fieldDictionary.isMultiEdited ? 'drp-color-style-edit' : 'drp-color-style'"
                             [placeholder]="fieldDictionary.isMultiEdited ?'Value cleared' : 'Enter Value'" 
                             (ngModelChange)="fieldDictionary.isMultiEdited=true"
                            required="true">
                            <ng-template let-filterCols let-row pTemplate="item">
                              <div class="ui-helper-clearfix" style="text-transform:capitalize">
                                <div [matTooltip]="filterCols.description" [matTooltipShowDelay]="1000" matTooltipPosition="after" [id]="filterCols.label">{{filterCols.label}}</div>
                              </div>
                            </ng-template>
                          </p-select>
                        </ng-container>
                      }
                      @else if((fieldDictionary.uiDataType | lowercase) === 'string' || (fieldDictionary.uiDataType | lowercase) === 'char'){
                        <ng-container>
                          @if((fieldDictionary.fieldName | lowercase) !== 'symbol' && (fieldDictionary.fieldName | lowercase) !== 'type'){
                          <input
                            [name]="fieldDictionary.fieldName" [id]="fieldDictionary.fieldName" 
                            pInputText required 
                            [placeholder]="fieldDictionary.isMultiEdited ?'Value cleared' : 'Enter Value'" 
                            (ngModelChange)="fieldDictionary.isMultiEdited=true" 
                            [ngClass]="fieldDictionary.isMultiEdited ? 'input-color-edit' : 'inp-color-white'"
                           [(ngModel)]="fieldDictionary.jsonValue" [disabled]="fieldDictionary.disabled"/>
                          }
                           @if((fieldDictionary.fieldName | lowercase) === 'symbol' || (fieldDictionary.fieldName | lowercase) === 'type'){
                          <input
                            [name]="fieldDictionary.fieldName" [id]="fieldDictionary.fieldName"
                            pInputText [placeholder]="fieldDictionary.isMultiEdited ?'Value cleared' : 'Enter Value'" 
                            (ngModelChange)="fieldDictionary.isMultiEdited=true" 
                            [ngClass]="fieldDictionary.isMultiEdited ? 'input-color-edit' : 'inp-color-white'"
                            [(ngModel)]="fieldDictionary.jsonValue" [disabled]="fieldDictionary.disabled"/>
                           }
                        </ng-container>
                      }
                      @else if((fieldDictionary.uiDataType | lowercase)==='date'){
                        <ng-container>
                          <p-datepicker appendTo="body"
                          [touchUI]="true"
                          [name]="fieldDictionary.fieldName" [id]="fieldDictionary.fieldName"
                          [(ngModel)]="fieldDictionary.jsonValue" 
                          dateFormat="yyyy-mm-dd"
                          [hourFormat] = "'24'"
                          [style]="{'width': '95%'}"
                          [placeholder] = "'Enter Value'"
                          [required] = "true"
                          [inputId]="fieldDictionary.fieldName"
                          [motionOptions]="{ duration: 0 }"/>
                        </ng-container>
                      }
                      @else if((fieldDictionary.uiDataType | lowercase)==='datetime'){
                        <ng-container>
                          <div class="ui-g-12 nopadding ">
                            <input [name]="fieldDictionary.fieldName" [id]="fieldDictionary.fieldName" type="text"
                            [placeholder]="fieldDictionary.isMultiEdited ?'Value cleared' : 'Enter Value'" 
                            (ngModelChange)="fieldDictionary.isMultiEdited=true" 
                            [ngClass]="fieldDictionary.isMultiEdited ? 'input-color-edit' : 'inp-color-white'" pInputText [(ngModel)]="fieldDictionary.jsonValue" />
                          </div>
                        </ng-container>
                      }
                      @else if((fieldDictionary.uiDataType | lowercase)==='timestamp'){
                        <ng-container>
                          <div class="ui-g-12 nopadding ">
                            <input [name]="fieldDictionary.fieldName" [id]="fieldDictionary.fieldName" type="text"
                            [placeholder]="this.userService.getDateTimeTFormatePattern(fieldDictionary.fieldName)" 
                            [matTooltip]="this.userService.getDateTimeTFormatePattern(fieldDictionary.fieldName)"
                            (input)="getDateTimeTFormate(fieldDictionary.fieldName,$event,i)"
                            [ngClass]="this.userService.timeStampErrorField == fieldDictionary.fieldName ?'error_timeStamp' :fieldDictionary.isMultiEdited ? 'input-color-edit' : 'inp-color-white'" pInputText
                            [(ngModel)]="fieldDictionary.jsonValue"
                            (ngModelChange)="fieldDictionary.isMultiEdited=true" 
                             />
                          </div>
                        </ng-container>
                      }
                      @else if((fieldDictionary.uiDataType | lowercase)==='choicevalues'){
                        <ng-container>
                          <!--Special case-->
                          @if((fieldDictionary.fieldName | lowercase) === 'timeinforce'){
                          <ng-container>
                            @if(fieldDictionary.fieldName === 'timeInForce'){
                          <div class="ui-g-12 ui-md-6 ui-lg-4 quick-view-grid-row-hg">
                            <p-select [name]="fieldDictionary.fieldName +'choicevaluesDropdown'" [id]="fieldDictionary.fieldName+'choicevaluesDropdown'" 
                              [options]="fieldDictionary.choiceDetails"
                              [(ngModel)]="timeInForceChoice" appendTo="body" (onChange)="setEditRowValue(i,timeInForceChoice)"
                              [styleClass]="fieldDictionary.isMultiEdited ? 'drp-color-style-edit' : 'drp-color-style'"
                              [placeholder]="timeInForceChoice"
                               filter="true" required="true"
                               class="timeInForceDropdown">
                              <ng-template let-filterCols let-row let-rowIndex pTemplate="item">
                                <div class="ui-helper-clearfix" style="text-transform:capitalize">
                                  <div [matTooltip]="filterCols.description" [matTooltipShowDelay]="1000" matTooltipPosition="after" [id]="filterCols.label">{{filterCols.label}}
                                  </div>
                                </div>
                              </ng-template>
                            </p-select>
                          </div>
                          }
                          <div class="ui-g-12 ui-md-6 ui-lg-8 quick-view-grid-row-hg">
                            <input [name]="fieldDictionary.fieldName" [id]="fieldDictionary.fieldName" required type="text"
                            [placeholder]="fieldDictionary.isMultiEdited ?'Value cleared' : 'Enter Value'" 
                            (ngModelChange)="fieldDictionary.isMultiEdited=true" 
                            [ngClass]="fieldDictionary.isMultiEdited ? 'input-color-edit' : 'inp-color-white'" pInputText [(ngModel)]="timeInForceValue" />
                          </div>
                          </ng-container>
                          }
                          <!--End of special case-->
                        </ng-container>
                      }
                    </div>
                    @if(this.correctCodeLength !== 0 && !fieldDictionary.disabled){
                    <div class="ui-g-12 ui-md-1 ui-lg-1 quick-view-grid-row-hg">
                      <i pTooltip="Clear Value" (click)="clearValue(fieldDictionary)" tooltipPosition="right" class="fa fa-times cursor-pointer clear-all-icon"  aria-hidden="true"></i>
                    </div>
                    }
                  </div>
                </span>
              </ng-container>
            }
            </ng-container>
            }
            @for(fieldDictionary of fieldDictionaryList; track fieldDictionary.fieldName + '-'+ $index; let i = $index) {
            <ng-container>
              @if(!( (fieldDictionary.fieldName | lowercase) !== 'buydetails' && (fieldDictionary.fieldName | lowercase) !== 'selldetails' && (fieldDictionary.fieldName | lowercase) !== 'aggregatedorders'
              && (fieldDictionary.fieldName | lowercase) !== 'clientdetails' &&  (fieldDictionary.fieldName | lowercase) !== 'firmdetails' && (fieldDictionary.fieldName | lowercase) !== 'handlinginstructions'
              && (fieldDictionary.fieldName | lowercase) !== 'legdetails' 
              && (fieldDictionary.fieldName | lowercase) !== 'firmdesignatedid')){
              <ng-container>
                <span class="zindex ui-g-12 ui-md-12 ui-lg-12">
                             <!-- firmDesignatedID Details -->
                              @if(fieldDictionary.fieldName=='firmDesignatedID'){
                             <div class="nopadding dialog-normal-form-field">
                              <div class="col-md-5 nopadding ">
                                 <div class="row ">
                                   <div class="col-md-3 dialog-form-field"><label for="GivenName">GivenName</label></div>
                                     <div class="col-md-2"><p-toggleswitch [(ngModel)]="checked" styleClass="inputSwitch"></p-toggleswitch></div>
                                     <div class="col-md-7"> <input [disabled]="!checked" placeholder="Enter givenName" [(ngModel)]="givenNameForFDID" >
                                       <p-button type="button" icon="fa fa-check" [disabled]="!checked" (click)="getFDID(i)"></p-button></div>
                                  </div> 
                              </div>
                              <div class="col-md-7 nopadding">
                                <div class="row">
                                   <div class="col-md-4"><label for="FirmDesignatedID">Firm Designated ID</label> </div>
                                   <div class="col-md-1"><p-toggleswitch (click)="fieldDictionary.jsonValue = dataService.trimValue(fieldDictionary.jsonValue)" [(ngModel)]="fdidChecked" styleClass="inputSwitch"></p-toggleswitch></div>
                                   <div class="col-md-7"> <input [disabled]="!fdidChecked" placeholder="Enter Firm Designated ID" (change)="fieldDictionary.jsonValue = dataService.trimValue(fieldDictionary.jsonValue)" [(ngModel)]="fieldDictionary.jsonValue" style="width: 100%"></div>
                                </div> 
                              </div>
                             </div>
                              }
                  
                  <!--Special cases-->
                  @if((fieldDictionary.fieldName| lowercase) === 'aggregatedorders'){
                 <div class="ui-grid-col-12 horizontal-scroll">
                    <mat-divider></mat-divider>
                    <span class="dialog-section-header"><b>Aggregated Order Details</b></span>
                    <p-table [columns]="aggoOrdersCols" [value]="fieldDictionary.jsonValue" #dt1 class="cell-editor-table">
                      <ng-template pTemplate="header" let-columns>
                        <tr>
                          <th id="header"></th>
                          @for(col of columns; track col.header + '-'+ $index) {
                          <th id="columns" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                            {{col.header}}
                          </th>
                          }
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-aggoOrdersRowData let-ri="rowIndex" let-columns="columns">
                        <tr [pSelectableRow]="aggoOrdersRowData" [pSelectableRowIndex]="ri">
                          <!-- Logic of Aggo Details Add/Delete Row -->
                            @if((fieldDictionary.fieldName | lowercase)==='aggregatedorders' && (fieldDictionary.jsonValue.length === (ri+1))){
                              <td class="text-center">
                                @if(fieldDictionary.jsonValue.length > 1) {
                                  <a (click)="dataService.removeJsonFieldDetails(fieldDictionary.jsonValue, ri);clearErrorFieldValue();"><em class="pi pi-minus"></em></a>&nbsp;
                                }
                                <a (click)="dataService.addJsonFieldDetails(fieldDictionary.jsonValue, 'aggregatedOrders');"><em class="pi pi-plus"></em></a>
                              </td>
                            }
                            @if((fieldDictionary.fieldName | lowercase)==='aggregatedorders' && (fieldDictionary.jsonValue.length !== (ri+1))){
                              <td class="text-center"><a (click)="dataService.removeJsonFieldDetails(fieldDictionary.jsonValue, ri);clearErrorFieldValue();"><em class="pi pi-minus"></em></a></td>
                            }
                          <!-- End Logic of Aggo Details Add/Delete Row -->
                          @for(col of columns; track col.field + '-'+ $index) {
                          <td pEditableColumn [ngClass]="this.userService.timeStampErrorField == (col.field + '_'+ ri) ? 'error_orderKeyDate' : (col?.display | lowercase) === 'false' ? 'notdisplay':''">
                          <p-cellEditor>
                              <ng-template pTemplate="input">
                                @if(col.field == 'orderKeyDate'){
                                <input  [name]="col.field +'inp'" [id]="col.field+'inp'"  [(ngModel)]="aggoOrdersRowData[col.field]"
                                (change)="getOrderKeyDateFormate(col.field,$event,ri)" placeholder="yyyyMMddT000000">
                                }
                                @else{
                                  <input  [name]="col.field +'inp'" [id]="col.field+'inp'"  [(ngModel)]="aggoOrdersRowData[col.field]">
                                }
                              </ng-template>
                              <ng-template pTemplate="output">
                                <span>
                                  {{aggoOrdersRowData[col.field]}}
                                </span>
                              </ng-template>
                          </p-cellEditor>
                          </td>
                          }
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                  }
                  @if(fieldDictionary.fieldName=='handlingInstructions'){
                  <div class="ui-grid-col-8 container nopadding dialog-normal-form-field">
                    <mat-divider></mat-divider>
                    <p-table id = "handlingInstructionTable" [columns]="handlingInstructionCols" [value]="handlingInstructionData" #dt2
                    class="cell-editor-table">
                      <ng-template pTemplate="caption">
                        <div class="row">
                            <div class="col-md-4" style="text-align:left">
                                <span class="dialog-section-header"><b>Handling Instructions</b></span>
                              </div>
                              <div class="col-md-4" style="text-align:left">
                                <p-multiSelect [name]="fieldDictionary.fieldName +'multiselect'" id="handlingInstructionsMultiselect" appendTo="body" 
                                [options]="this.userService.handlingInstructions" [(ngModel)]="handlingInstructionCols" optionLabel="header"
                                 selectedItemsLabel="{0} columns selected" [style]="{minWidth: '200px'}"  placeholder="Choose Columns"
                                 class="finra-exp-select"></p-multiSelect>
                            </div>
                        </div>     
                    </ng-template>
                      <ng-template pTemplate="header" let-columns>
                        <tr>
                          @for(col of columns; track col.header + '-'+ $index) {
                          <th id="colHeader">
                            {{col.header}}
                          </th>
                          }
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-handlingInstructionData let-columns="columns">
                        <tr >
                          @for(col of columns; track col.field + '-'+ $index) {
                          <td style="width:10px" pEditableColumn>
                            <p-cellEditor>
                              <ng-template pTemplate="input">
                                <input  [name]="fieldDictionary.fieldName +'inp'" [id]="fieldDictionary.fieldName+'inp'"  
                                [(ngModel)]="handlingInstructionData[col.field]">
                              </ng-template>
                              <ng-template pTemplate="output">
                                <span >
                                  {{handlingInstructionData[col.field]}}
                                </span>
                              </ng-template>
                          </p-cellEditor>
                          
                          </td>
                          }
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                  }
                  
                  <!-- TDET Grid -->
                   @if(( (fieldDictionary.fieldName | lowercase) === 'buydetails' || (fieldDictionary.fieldName | lowercase) === 'selldetails' ||
                   (fieldDictionary.fieldName | lowercase) === 'clientdetails' || (fieldDictionary.fieldName | lowercase) === 'legdetails' || (fieldDictionary.fieldName | lowercase) === 'firmdetails' )){
                  <div class="ui-grid-col-12 horizontal-scroll">
                    <mat-divider></mat-divider>
                    <span class="dialog-section-header"><b>{{(fieldDictionary.fieldName | lowercase) === 'buydetails' ? 'Buy Details': (fieldDictionary.fieldName | lowercase) === 'selldetails' ? 'Sell Details' : (fieldDictionary.fieldName | lowercase) === 'clientdetails' ? 'Client Details': (fieldDictionary.fieldName | lowercase) =='firmdetails' ? 'Firm Details': (fieldDictionary.fieldName | lowercase) =='legdetails' ? 'Leg Details':''}}</b></span>
                    <p-table resizableColumns=false 
                      [columns]="getChildColumns(fieldDictionary.fieldName)" [value]="fieldDictionary.jsonValue" #dt21
                      class="cell-editor-table">
                      <ng-template pTemplate="header" let-columns>
                        <tr>
                          @if((fieldDictionary.fieldName | lowercase)==='legdetails') {
                            <th id="tableHeader"></th>
                          }
                          @for(col of columns; track col.header + '-'+ $index) {
                          <th id="columns" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                            {{col.header}}
                          </th>
                          }
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-tradeSideRowData let-rowIndex="rowIndex" let-columns="columns">
                        <tr [pSelectableRow]="tradeSideRowData">
                          <!-- Logic of Leg Details Add/Delete Row Buttons -->
                            @if((fieldDictionary.fieldName | lowercase)==='legdetails' && (fieldDictionary.jsonValue.length === (rowIndex+1))){
                              <td class="text-center">
                                @if(fieldDictionary.jsonValue.length > 1) {
                                  <a (click)="dataService.removeJsonFieldDetails(fieldDictionary.jsonValue, rowIndex)"><em class="pi pi-minus"></em></a>&nbsp;
                                }
                                <a (click)="dataService.addJsonFieldDetails(fieldDictionary.jsonValue, 'legDetails');"><em class="pi pi-plus"></em></a>
                              </td>
                            }
                            @if((fieldDictionary.fieldName | lowercase)==='legdetails' && (fieldDictionary.jsonValue.length !== (rowIndex+1))){
                              <td class="text-center"><a (click)="dataService.removeJsonFieldDetails(fieldDictionary.jsonValue, rowIndex)"><em class="pi pi-minus"></em></a></td>
                            }
                          <!-- End Logic of Leg Details Add/Delete Row Buttons -->
                          @for(col of columns; track col.field + '-'+ $index) {
                          <td [style]="(fieldDictionary.fieldName | lowercase)==='side' || (fieldDictionary.fieldName | lowercase)==='accountholdertype' ? 'min-width: 160px !important' : 'min-width: 30px  !important'" pEditableColumn [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                          <p-cellEditor>
                            <ng-template pTemplate="input">
                              @if((col.datatype | lowercase) !='int' && (col.datatype | lowercase) !='float' && (col.datatype | lowercase) !='boolean' && (col?.dropdown | lowercase) === 'no'){
                                <input [name]="col.header +'inp'" [id]="col.header+'inp'" [(ngModel)]="tradeSideRowData[col.field]">
                              }
                              <!-- set dropdown -->
                                @if((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'yes' && (col?.dropdowntype | lowercase) === 'singleselect'){
                                  <p-select styleClass="tbl-form-dropdown" appendTo="body" [name]="tradeSideRowData[col.field]+'singleselect'" [id]="tradeSideRowData[col.field]+'singleselect'" 
                                    [options]="getCATDetailsFieldDropdownValues(fieldDictionary, col, tradeSideRowData)" [(ngModel)]="tradeSideRowData[col.field]" [disabled]="col.disabled" [showClear]="true" 
                                    [placeholder]="'Enter Value'">
                                  </p-select>
                                }
                              <!-- set int  -->
                              @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float'){
                                <input style="float:right;" [name]="col.header +'inp'" [id]="col.header+'inp'"
                                [(ngModel)]="tradeSideRowData[col.field]">
                              }
                              <!-- set boolean -->
                              @if((col.datatype | lowercase)==='boolean') {
                              <p-select [name]="fieldDictionary.fieldName + 'boolean'" [id]="fieldDictionary.fieldName + 'boolean'" [options]="booleanDropDown" [(ngModel)]="tradeSideRowData[col.field]" appendTo="body"
                                [styleClass]="fieldDictionary.isMultiEdited ? 'drp-color-style-edit' : 'drp-color-style'"
                                [placeholder]="fieldDictionary.isMultiEdited ? 'Value cleared' : 'Enter Value'" [showClear]="true"
                                (ngModelChange)="fieldDictionary.isMultiEdited=true" filter="true"></p-select>
                              }
                            </ng-template>
                            <ng-template pTemplate="output">
                              @if((col.datatype | lowercase) !='int' && (col.datatype | lowercase) !='float'){
                              <span>
                                {{tradeSideRowData[col.field]}}
                              </span>
                              }
                              <!-- set int  -->
                               @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float'){
                              <span style="float:right;">
                                {{tradeSideRowData[col.field]}}
                              </span>
                              }
                            </ng-template>
                        </p-cellEditor>
                          
                          </td>
                          }
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                  }
               
                 <!--Special cases-->
                </span>
              </ng-container>
              }
            </ng-container>
            }
          </div>
        </mat-step>
            @if(isShowConvertEventStepper && this.correctCodeLength === 0){
            <mat-step label="Convert Event">
                <app-event-conversion [selectedRow]="finraException" (closeDialog)="closeDialog.emit($event);finraExceptionService.showEdit =false"
                 [pageName]="'finraException'" [fieldDictionaryListInput]="fieldDictionaryList" #eventConvert></app-event-conversion>
              </mat-step>
            }
        </mat-horizontal-stepper>
  @if(selectedTabIndex === 0){
    <ng-template #footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      @if(convertLable.trim().length > 0){
      <p-button type="button" id="convertEvent"
        [label]="convertLable" (click)="nextStepper(matStepperOne)" matStepperNext>
      </p-button>
      }
      <p-button type="button" icon="fa fa-close" id="catExceptionClose" class="userActionBtn finra-close-footer-button finra-edit-footer-button" 
        (click)="previousStepper(matStepperOne);onClose();" label="Close">
      </p-button>
      <p-button type="button" icon="fa fa-check" [disabled]="isClickedOnce || !!this.userService.timeStampErrorField"  class="userActionBtn finra-edit-footer-button" (click)="onSave()" id="FinraExceptionSave" label="Save"></p-button>
    </div>
    </ng-template>
  }
</p-dialog>